// 活动提报列表页查询条件状态管理

const state = {
  // 默认查询条件
  defaultQueryCondition: {
    applyNameOrCode: null,
    applyStatus: null,
    planWriteOffStatus: null,
    itemType: null,
    actMonthStart: null,
    actMonthEnd: null,
    budgetData: null,
    planCode: null,
    planApplyCode: null,
    regionIds: [],
    dealerIds: [],
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null
  },
  // 查询条件
  queryCondition: {
    applyNameOrCode: null,
    applyStatus: null,
    planWriteOffStatus: null,
    itemType: null,
    actMonthStart: null,
    actMonthEnd: null,
    budgetData: null,
    planCode: null,
    planApplyCode: null,
    regionIds: [],
    dealerIds: [],
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null
  },
  // 分页条件
  pagination: {
    current: 1,
    size: 20,
    total: 0
  },
  // 显示更多筛选
  showFilter: false,
  // 五级来源1、2、3级下拉列表
  sourceList: {
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  },
  defaultSourceList: {
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  }
}

const mutations = {
  // 更新查询条件
  updateQueryCondition: (state, newCondition) => {
    state.queryCondition = newCondition
  },
  // 重置查询条件
  resetQueryCondition(state) {
    state.queryCondition = { ...state.defaultQueryCondition }
    state.pagination = {
      current: 1,
      size: 20,
      total: 0
    }
    state.sourceList.twoSourceList = state.defaultSourceList.twoSourceList
    state.sourceList.threeSourceList = state.defaultSourceList.threeSourceList
  },
  // 更新分页条件
  updatePagination(state, newPagination) {
    state.pagination = newPagination
  },
  updateShowFilter(state, newState) {
    state.showFilter = newState
  },
  updateSourceList(state, newState) {
    switch (newState.level) {
      case 1: state.sourceList.oneSourceList = newState.list
        break
      case 2:
        state.queryCondition.twoLevelCode = null
        state.queryCondition.threeLevelCode = null
        state.sourceList.twoSourceList = newState.list
        break
      case 3:
        state.queryCondition.threeLevelCode = null
        state.sourceList.threeSourceList = newState.list
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
